import { render, staticRenderFns } from "./UnitManage.vue?vue&type=template&id=2c860334&scoped=true&"
import script from "./UnitManage.vue?vue&type=script&lang=js&"
export * from "./UnitManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c860334",
  null
  
)

export default component.exports